import { LoadingState } from '@/components/shared';
import { useSeoFetch } from '@/hooks/useSeoFetch';
import dbSchemaService, { DbSchema } from '@/services/dbSchema';
import DbErdComponent from './DbErd.component';

const DbErdContainer = function (): JSX.Element {
  const { data: schema, isLoading } = useSeoFetch<DbSchema>(
    ['db-schema'],
    () => dbSchemaService.getSchema(),
    { retry: false }
  );

  if (isLoading || !schema) return <LoadingState message="Loading database schema..." />;

  return <DbErdComponent schema={schema} />;
};

export default DbErdContainer;
